import { useEffect, useState } from "react";
function useMediaQuery(query) {
    const [matches, setMatches] = useState(()=>{
        if ("undefined" != typeof globalThis && "function" == typeof globalThis.matchMedia) return globalThis.matchMedia(query).matches;
        return false;
    });
    useEffect(()=>{
        if ("undefined" == typeof globalThis) return;
        const mediaQueryList = globalThis.matchMedia(query);
        const onChange = (event)=>{
            setMatches(event.matches);
        };
        mediaQueryList.addEventListener("change", onChange);
        return ()=>{
            mediaQueryList.removeEventListener("change", onChange);
        };
    }, [
        query
    ]);
    return matches;
}
export { useMediaQuery };
